const state = {
  userSetting: {},
  userAvatar: {}
}

const getters = {
  userSetting: state => state.userSetting,
  userAvatar: state => state.userAvatar
}

const types = {
  setUserSetting: 'global/userSetting',
  setUserAvatar: 'global/setUserAvatar'
}

const mutations = {
  [types.setUserSetting] (state, obj) {
    state.userSetting = obj
  },
  [types.setUserAvatar] (state, obj) {
    state.userAvatar = obj
  }
}

const actions = {
  setUserSettingAction ({commit}, obj) {
    commit(types.setUserSetting, obj)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js